import React from 'react';
import { Paragraph } from '@uncinc/react-drupal-core';
import { List } from 'immutable';
import { WysiwygField, Container } from '@uncinc/uncinc-react-kitchen-sink';

import {
  PARAGRAPH_VIEW_MODE_FULLSCREEN,
} from '../../../config/constants';

import './style.scss';

const NodeAnnualReportArticle = ({ entity }) => {
  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed']);
  const colorVariant = entity.getIn(['field_annual_report_theme', 0, 'entity', 'field_color_variant', 0, 'value'], '');

  return (
    <article className={`NodeAnnualReportArticle AnnualReportTheme--${colorVariant}`}>
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div className="NodeAnnualReportArticle__content">
              <h1 className="asH2 NodeAnnualReportArticle__content__title">{title}</h1>
              <WysiwygField
                property="schema:text"
                html={body}
                className="NodeAnnualReportArticle__content__body"
              />
            </div>
          </div>
        </div>
      </Container>

      {/* Start of regular paragraphs */}
      {entity.get('field_paragraphs') && (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');

            return (
              <Paragraph
                key={`paragraph:${id}`}
                id={id}
                entity={paragraph.get('entity')}
              />
            );
          })}
        </div>
      )}
      {/* End of regular paragraphs */}
      {/* Start of annual report paragraphs */}
      {entity.get('field_annual_report_paragraphs') && (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_annual_report_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');

            return (
              <Paragraph
                key={`paragraph:${id}`}
                id={id}
                entity={paragraph.get('entity')}
                viewMode={PARAGRAPH_VIEW_MODE_FULLSCREEN}
              />
            );
          })}
        </div>
      )}
      {/* End of annual report paragraphs */}
    </article>
  );
};

export default NodeAnnualReportArticle;
